import {
    InfoOutlined,
    NavigateBefore,
    PushPinOutlined,
} from '@mui/icons-material';
import {
    Avatar,
    Badge,
    Box,
    IconButton,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React from 'react';
import { useChannelStateContext } from 'stream-chat-react';

interface ChannelHeaderProps {
    handleBack: () => void;
    handleOpen: () => void;
    handlePinnedMessages: () => void;
}

const ChannelHeader = ({
    handleBack,
    handleOpen,
    handlePinnedMessages,
}: ChannelHeaderProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { channel, pinnedMessages } = useChannelStateContext();

    const { name, member_count, image } = channel.data || {};
    const { watcher_count } = channel.state || {};

    return (
        <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            px={2}
            py={2}
            gap={2}
        >
            <Box display='flex' alignItems='center' gap={2} overflow='hidden'>
                {isMobile && (
                    <IconButton onClick={handleBack}>
                        <NavigateBefore />
                    </IconButton>
                )}
                {!isMobile && <Avatar variant='rounded' src={image} />}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    <Typography
                        variant='h6'
                        sx={{
                            color: 'text.primary',
                            fontWeight: 'bold',
                            fontSize: '18px',
                            overflow: 'hidden', // Hide overflow text
                            textOverflow: 'ellipsis', // Show ellipsis when text overflows
                            whiteSpace: 'nowrap', // Prevent wrapping
                        }}
                    >
                        {name}
                    </Typography>
                    <Typography
                        sx={{ color: 'text.primary', fontSize: '14px' }}
                    >
                        {`${member_count} members, ${watcher_count} online`}
                    </Typography>
                </Box>
            </Box>
            <Stack direction='row'>
                <IconButton>
                    <Badge
                        badgeContent={pinnedMessages?.length}
                        variant='dot'
                        color='primary'
                    >
                        <PushPinOutlined
                            color='primary'
                            onClick={handlePinnedMessages}
                        />
                    </Badge>
                </IconButton>
                <IconButton onClick={handleOpen}>
                    <InfoOutlined color='primary' />
                </IconButton>
            </Stack>
        </Box>
    );
};

export default ChannelHeader;
